import { ContentWithDetail } from '@knowledge/knowledges/SupplementKnowledge/AdjustRelateKnowledge/ContentWithDetail';
import { EmptyPlaceholder } from '@knowledge/knowledges/SupplementKnowledge/EmptyPlaceholder';
import { useTranslate } from '@tolgee/react';
import { useRequest } from 'ahooks';
import { Drawer, DrawerProps, message } from 'antd';
import { FullLoading } from 'components/FullLoading';
import useModal from 'hooks/useModal';
import { getMercadoQaSupplementKnowledgeDetail } from 'services/api/supplementKnowledge';

interface Props extends DrawerProps {
  questionId: string;
}

function QAPairDrawer({ questionId, ...otherProps }: Props) {
  const { t } = useTranslate();

  const { data, loading } = useRequest(
    () => {
      return getMercadoQaSupplementKnowledgeDetail(questionId);
    },
    {
      refreshDeps: [questionId],
      onError: () => message.error(t('phrase.获取数据失败，请稍后再试')),
    },
  );

  return (
    <Drawer
      title={t('调整相关知识')}
      width={640}
      bodyStyle={{
        padding: 0,
      }}
      {...otherProps}
    >
      {loading ? (
        <FullLoading />
      ) : data ? (
        <ContentWithDetail
          supplementKnowledgeDetail={data}
          onDone={() => otherProps.onClose?.({} as any)}
        />
      ) : (
        <EmptyPlaceholder />
      )}
    </Drawer>
  );
}

export function useQAPairDrawer() {
  const { visible, show, hide, meta } = useModal<Props>();

  const drawer = meta && <QAPairDrawer {...meta} visible={visible} onClose={() => hide()} />;

  return [drawer, show] as const;
}

export default QAPairDrawer;
